<template lang="html">
    <div class="day" :class="{ active: day.active }">
        <span>{{ dayCharacter }}</span>
        <input type="radio" name="" value="" />

        <router-link
            v-if="day.active"
            :to="{ name: 'proLessonAvailabilityDay', params: { id: day.day } }"
            class="button dark"
        >
            {{ day.active ? "Edit" : "Add" }} times
            <img class="avialbleArrow" src="~@/assets/arrow-right-white-2.svg" />
        </router-link>
        <button
            @click.prevent="deleteDay"
            v-if="day.active"
            class="button red"
            type="button"
            name="button"
        >
            <img src="~@/assets/minus.svg" />
        </button>

        <router-link
            v-if="!day.active"
            :to="{ name: 'proLessonAvailabilityDay', params: { id: day.day } }"
            class="button makeAvailable"
            type="button"
        >
            Make available
            <img class="avialbleArrow" src="~@/assets/arrow-right-white.svg" />
        </router-link>
    </div>
</template>

<script>
import { Form } from "vform";

export default {
    name: "day-item",
    props: {
        day: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            form: new Form(),
        };
    },
    computed: {
        dayCharacter() {
            return this.day.day.charAt(0);
        },
    },
    methods: {
        deleteDay() {
            this.form.day = this.day.dayIndex;

            this.$confirm(
                "Changes to your availability will have an impact on future bookings. Affected bookings will be automatically cancelled and Players notified of any changes made.",
                () => {
                    this.form
                        .delete("/recurring/availability?day=" + this.day.dayIndex)
                        .then(() => {
                            this.$emit("removeDay", this.day.dayIndex);
                            this.$notify({
                                duration: 1000,
                                text: "That day has been removed",
                            });
                        });
                },
                "Yes, continue",
                "No, cancel",
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.day {
    display: flex;
    margin-bottom: 10px;
    position: relative;
    .arrow {
        float: right;
        transform: translateY(3px);
        display: block;
    }
    .avialbleArrow {
        position: absolute;
        right: 20px;
        top: 19px;
    }
    span {
        position: absolute;
        left: 21px;
        top: 18px;
        color: $green_0;
        pointer-events: none;
        text-transform: uppercase;
    }
    input[type="radio"] {
        padding: 0px;
        margin: 0px;
        flex: 0 0 54px;
        display: block;
        background: $green_light;
        margin-right: 10px;
        appearance: none;
        width: 52px;
        height: 52px;
        border-radius: $radius;
        color: $green_0;
        border: 0px;
        flex: 0 0 52px;
        &:focus {
            outline: 0;
        }
    }
    button {
    }
    a {
        margin-right: 10px;
    }
    .makeAvailable {
        position: relative;
        background: $green_light;
        color: $green_0;
        text-align: left;
        margin-right: 0px;
        .icon {
            position: absolute;
            left: auto;
            right: 20px;
        }
    }

    &.active {
        input[type="radio"] {
            background: $green_1;
        }
        span {
            color: white;
        }
        button {
            background: $red;
            flex: 0 0 52px;
            color: white;
            .icon {
                position: absolute;
                left: 16px;
                right: auto;
            }
        }
    }
}
</style>
